export async function Language(token: string | null) {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/language',
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }

    const request = await axios.request(options);
    return request;
}